exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! @name videojs-logo @version 2.1.6 @license MIT */\n.video-js.vjs-logo{display:block}.video-js.vjs-logo .vjs-logo-content{position:absolute;opacity:1;transition:visibility 2s,opacity 2s}.video-js.vjs-logo .vjs-logo-content.vjs-logo-hide{visibility:hidden;opacity:0}", ""]);

// exports
